import React, { useEffect, useState, Suspense } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import { FaThreads } from "react-icons/fa6";
import { FiPhone, FiMail, FiMapPin } from "react-icons/fi";

import logo from "../../assets/img/Rentel-10.png";
import Appstore from "../../assets/img/appstore.png";
import Downloads from "../../assets/img/playstor.png";
import "../../assets/css/Footer.css";

// Lazy wrappers
const NoCopyWrapper = React.lazy(() => import("../../utils/NoCopyWrapper"));
const NoZoomWrapper = React.lazy(() => import("../../utils/NoZoomWrapper"));

const Footer = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  // ✅ FETCH SAME CATEGORY API AS Manu
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(
          "https://network.rentel.in/categories/get"
        );
        setCategories(res.data.categories || []);
      } catch (error) {
        console.error("Category fetch failed", error);
      }
    };

    fetchCategories();
  }, []);


  // ✅ SAME NAVIGATION LOGIC AS Manu
  const handleCategoryClick = (categoryName) => {
    const cat = categories.find((c) => c.name.trim().toLowerCase() === categoryName.trim().toLowerCase());
    if (!cat) return;
    const name = cat.name.trim().toLowerCase();
    if (name === "cloth") {
      navigate("/category/cloth/men", { state: { categoryId: cat._id } });
    } else if (name === "vehicles") {
      navigate("/category/vehicles/car", { state: { categoryId: cat._id } });
    } else if (name === "events") {
      navigate("/category/events/dj & sound", { state: { categoryId: cat._id } });
    } else if (name === "machinery") {
      navigate("/category/machinery/construction machinery", { state: { categoryId: cat._id } });
    } else {
      navigate(`/category/${name}`, { state: { categoryId: cat._id } });
    }
  };

  return (
    <NoZoomWrapper>
      <NoCopyWrapper>
        <footer className="footer">

          {/* ===== BROWSE BY TYPE (FIXED & WORKING) ===== */}
          <div className="browse-by-type">
            <span>Browse by Type:</span>

            <div className="browse-links">
              {categories.length > 0 ? (
                categories.map((cat, index) => (
                  <React.Fragment key={cat._id || index}>
                    <span
                      key={cat.name}
                      className="browse-link"
                      onClick={() => handleCategoryClick(cat.name)}
                    >
                      {cat.name}
                    </span>
                    {index !== categories.length - 1 && <span> | </span>}
                  </React.Fragment>
                ))
              ) : (
                <span className="no-category">No categories available</span>
              )}
            </div>

          </div>

          {/* ===== MAIN FOOTER ===== */}
          <div className="footer-container">

            {/* BRAND */}
            <div className="footer-col brand">
              <img src={logo} alt="Rentel" />
              <p> Rentel is a smart rental marketplace where you can{" "}
                <strong>rent or lend</strong> clothes, electronics,
                vehicles, and more. Save money, earn extra, and enjoy hassle-free renting anytime, anywhere.
                <br /> <strong>Why buy? Just Rent!</strong> </p>

              <div className="social-icons">
                <a
                  href="https://www.facebook.com/profile.php?id=61584278505265"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://www.instagram.com/rentel.in/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://www.threads.com/@rentel.in"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaThreads />
                </a>
              </div>
            </div>

            {/* MENU */}
            <div className="footer-loc">
              <div className="footer-col">
                <h4>| Menu</h4>
                <Link to="/">Home</Link>
                <Link to="/about">About us</Link>
                {/* <Link to="https://rentel.in/blog/">Blog</Link> */}
                <Link to="/contact">Contact us</Link>
              </div>

              <div className="footer-col">
                <h4>| Support</h4>
                <Link to="/terms">Terms of Use</Link>
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/FAQ">FAQ</Link>
              </div>
            </div>

            {/* CONTACT */}
            <div className="footer-cola">
              <h4>| Contact Us</h4>
              <p><FiPhone /> +91 99799 55319</p>
              <p><FiMail /> contact@rentel.in</p>
              <p className="numx">
                <FiMapPin className="iaco" /> MBC Shopping, Mota Varachha, Surat, Gujarat 394101
              </p>


              <div className="store-buttons-wrap">
                <p className="store-title">| GET YOUR APP TODAY</p>
                <div className="store-buttons"> <a href="https://apps.apple.com/in/app/rentel-rent-smart-live-better/id6744444463" target="_blank" rel="noopener noreferrer" >
                  <img src={Appstore} alt="App Store" /> </a> <a href="https://play.google.com/store/apps/details?id=com.rent.el.in" target="_blank" rel="noopener noreferrer" >
                    <img src={Downloads} alt="Google Play" /> </a> </div>
              </div>
            </div>
          </div>
          <div className="doted-line" />
          <div className="footer-bottom">
            © 2025 Rentel - All Rights Reserved. || A Unit Of{" "}
            <a
              href="https://descube.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="descube-link"
            >
              Descube IT Solution
            </a>
          </div>

        </footer>
      </NoCopyWrapper>
    </NoZoomWrapper >
  );
};

export default Footer;
